import { render, staticRenderFns } from "./CalDavSettings.vue?vue&type=template&id=b032513c&scoped=true"
import script from "./CalDavSettings.vue?vue&type=script&lang=js"
export * from "./CalDavSettings.vue?vue&type=script&lang=js"
import style0 from "./CalDavSettings.vue?vue&type=style&index=0&id=b032513c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b032513c",
  null
  
)

export default component.exports